import * as React from 'react';
import RecoveryPasswordForm from '@App/components/forms/RecoveryPasswordForm';
import { Title } from 'relevant-ui';

class RecoveryPasswordPage extends React.Component<any, any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      width: window.innerWidth,
      height: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = (event: Object) => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  render() {
    const { width } = this.state;

    return (
      <div className="loginPage">
        <div className="loginPage__wrapper">
          <Title
            title="Vous avez oublié votre mot de passe ?"
            subtitle="Entrez votre adresse email ci-dessous nous allons vous remettre sur les rails."
            color={width <= 991 ? 'white' : 'black'}
          />
          <RecoveryPasswordForm />
        </div>
      </div>
    );
  }
}

export default RecoveryPasswordPage;
